import { CSSObject, Theme } from '@emotion/react';
import * as AlertStyle from '../Alert/style';

const wrap = AlertStyle.wrap;

const content = AlertStyle.content;

const buttonArea = (theme: Theme): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,

  '& > button': {
    flex: 1,
    height: '52px',
    borderRadius: theme.radius.md + 2,
    fontWeight: 600,
    fontSize: '16px',
    textAlign: 'center',
    transition: 'background-color 0.15s ease',
  },
  '& > button:first-of-type': {
    color: theme.color.grey700,
    background: theme.color.grey75,
    ':hover': {
      background: theme.color.grey100,
    },
  },
  '& > button:last-of-type': {
    color: theme.color.white,
    background: theme.color.primary,
    ':hover': {
      background: theme.color.primaryHover,
    },
  },
});

export { wrap, content, buttonArea };
